/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ObjectTypeModel, { ObjectTypeUsage } from 'cio/models/object-type';
import Component from '@glimmer/component';

interface Args {
  objectType: ObjectTypeModel;
  objectTypesUsage: Record<string, ObjectTypeUsage>;
}

export default class Usage extends Component<Args> {
  get usage() {
    return this.args.objectTypesUsage[this.args.objectType.id];
  }

  get isUsed() {
    return Object.values(this.usage).some((count) => count > 0);
  }
}
